// extracted by mini-css-extract-plugin
export default {"container":"style_container__BEK2e","titleSection":"style_titleSection__xz6i-"};